// extracted by mini-css-extract-plugin
export default {"burger_div":"BurgerButton_burger_div__ABkJp","burger_icon":"BurgerButton_burger_icon__cto0r"};